module.exports = __webpack_public_path__ + "media/storagemart-tab-logo.40b6d8a2.svg";